import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store';
import { GetNotifications } from '../store/actions/Notifications';
import { RootState } from '../store';

/**
 * Hook to sync notifications when user navigates to different pages
 * Uses debouncing to avoid spamming API calls during rapid navigation
 * IMPORTANT: Only syncs after auth/login is complete
 */
export const useNotificationSync = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state: RootState) => !!state.user?.userInfo?.UserID);
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const unsubscribe = history.listen(() => {
      // Clear existing debounce timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      // Set new debounce timer (500ms to avoid excessive API calls)
      debounceTimerRef.current = setTimeout(() => {
        dispatch(GetNotifications());
      }, 500);
    });

    return () => {
      unsubscribe();
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [history, dispatch, isAuthenticated]);
};
